import { getAppDescription } from "../shared/utils";
import { encodeXml } from "../shared/xmlUtils";
/**
 * Record the attachment and/or note in a <PolicyChangeSet>
 *
 * @param {Object} pacData
 * @param {String} note - The value of the `note` field in the form
 * @param {File|String} attachment - The value of the `attachment` field
 *   (empty string if not populated)
 */

export default function postPolicyChangeSet(_ref) {
  var attachment = _ref.attachment,
      note = _ref.note,
      _ref$pacData = _ref.pacData,
      apiPxcentralUrl = _ref$pacData.apiPxcentralUrl,
      apiRoot = _ref$pacData.apiRoot,
      apiIxlibraryBaseUrl = _ref$pacData.apiIxlibraryBaseUrl,
      apiIxlibraryUrl = _ref$pacData.apiIxlibraryUrl,
      applicationId = _ref$pacData.applicationId,
      InsightPolicyId = _ref$pacData.policyData.InsightPolicyId,
      username = _ref$pacData.username;
  // We're hard-coding this values for now. The `policy_attachments` part
  // appears to be configurable in policy central, but Marco gave the go-ahead
  // - Jim Nielsen May 23, 2017
  var ixLibraryBucket = "buckets/policy_attachments/objects"; // Kick off our request. First, if there's an attachment, upload it and get
  // the reference to it. Then, post a <PolicyChangeSet> for the <Note>,
  // <Attachment>, or both.

  return new Promise(function (resolve, reject) {
    // If there's no attachment, we don't need to do any uploading. Just
    // resolve with an empty value
    if (!attachment) {
      resolve("");
      return;
    } // If you get to here, there is an attachment. So we'll do the following:
    // 1. Upload the attachment to ixlibrary
    // 2. Parse the response for a reference to the X-Object-Key
    // 3. Resolve the promise with the object key (or reject with an error)
    // Get the attachment


    var formData = new FormData();
    formData.append("content-type", attachment.type);
    formData.append("object-data-file", attachment); // Post the attachment to ixlibrary
    // Docs: https://stage-sagesure-svc.icg360.org/cru-4/ixlibrary/api/sdo/rest/v1/documentation/

    fetch("" + (apiRoot || "") + apiIxlibraryUrl + "/" + ixLibraryBucket, {
      method: "POST",
      credentials: "include",
      headers: {
        'Accept': 'application/xml'
      },
      // Leave the `Content-Type` undefined, as the browser will set it for
      // us automatically (to multipart/form-data with boundaries)
      body: formData
    }).then(function (res) {
      if (!res.ok || res.status < 200 || res.status >= 300) {
        reject("Unexpected response while uploading attachment");
      } // Get the name of the uploaded attachment out of the X-Object-Key header


      var objectKeyForUploadedAttachment = res.headers.get('X-Object-Key');
      objectKeyForUploadedAttachment ? resolve(objectKeyForUploadedAttachment) : reject("Unable to properly parse attachment upload response.");
    }).catch(function (err) {
      reject("Error uploading attachment to ixlibrary", err);
    });
  }).then(function (objectKeyForUploadedAttachment) {
    return fetch(apiPxcentralUrl + "/policies/" + InsightPolicyId, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/xml; charset=UTF-8; schema=policychangeset.2.1",
        "X-Commit": true,
        Accept: "application/vnd.ics360.insurancepolicy.2.8+xml"
      },
      // We want this to all be one line, except for the note (if present)
      // because we want to maintain any line breaks that may be present there
      // prettier-ignore
      body: "" + ("<PolicyChangeSet schemaVersion=\"2.1\" username=\"" + username + "\" description=\"" + getAppDescription(applicationId) + "\">") + (objectKeyForUploadedAttachment ? "<Attachments>" + ("<Attachment name=\"" + encodeXml(attachment.name) + "\" contentType=\"" + attachment.type + "\">") + "<Description />" + ("<Location>" + apiIxlibraryBaseUrl + apiIxlibraryUrl + "/" + ixLibraryBucket + "/" + objectKeyForUploadedAttachment + "</Location>") + "</Attachment>" + "</Attachments>" : "") + (note ? "<Note>" + "<Content>" + ("<![CDATA[" + note + "]]>") + "</Content>" + "</Note>" : "") + "</PolicyChangeSet>"
    });
  }).then(function (res) {
    if (!res.ok) {
      throw new Error("Could not post the <PolicyChangeSet> to the server.");
    } // We don't really have to return anything here. If the response was ok,
    // then everything posted as we expect and that's all we're looking for.


    return ""; // res.text();
  });
}